import type React from 'react';

export function getOnEnterHandler(
  enterHandler: (event: React.KeyboardEvent) => void
): (event: React.KeyboardEvent) => void {
  return function onEnter(event: React.KeyboardEvent): void {
    if (event.key === 'Enter') enterHandler(event);
  };
}
